import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'
import { Colors } from '../../../util/util'

const styles = {
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    w: '100%',
    height: 50,
    zIndex: 8,
  } as BoxProps,
  subContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    w: '100%',
    height: 50,
    zIndex: 80,
    position: 'relative',
  } as BoxProps,
  wrap: {
    flexDirection: 'row',
    cursor: 'pointer',
    alignSelf: 'center',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    position: 'absolute',
    zIndex: 80,
    height: 50,
    flex: 1,
    width: '100%',
  } as BoxProps,
  input: {
    position: 'absolute',
    color: 'transparent',
    backgroundColor: 'transparent',
    width: '100%',
    height: 64,
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 100,
    outline: 'none',
    outlineColor: 'transparent',
    overflow: 'hidden',
    fontFamily: 'JioType-Bold',
  } as ViewStyle,
  display: (highlightBottom: boolean, inputType: string, index) =>
    ({
      borderWidth: inputType === 'box' ? (highlightBottom ? 1 : 1) : undefined,
      borderColor: inputType === 'box' ? (highlightBottom ? Colors.PRIMARY : 'GREY_1_SEPARATOR') : undefined,
      borderBottomWidth: highlightBottom ? 2 : 1,
      borderBottomColor: highlightBottom ? 'PRIMARY' : 'GREY_1_SEPARATOR',
      width: inputType === 'box' ? undefined : 30,
      height: 30,
      margin: inputType === 'box' ? 4 : 9,
      marginLeft: inputType === 'box' ? (index === 0 ? 0 : 4) : 9,
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      f: inputType === 'box' ? 1 : undefined,
      h: inputType === 'box' ? 64 : undefined,
      borderRadius: inputType === 'box' ? 8 : undefined,
    } as BoxProps),
  text: {
    fontSize: 25,
  },
  shadows: {
    // position: 'absolute',
    // left: -2,
    // top: -2,
    // bottom: -2,
    // right: -2,
    borderBottomColor: 'BLUE',
    borderBottomWidth: 2,
  } as unknown as BoxProps,
  dot: {
    height: 12,
    width: 12,
    borderRadius: 6,
    backgroundColor: 'BLACK',
  } as BoxProps,
  error: (highlightBottom: boolean, inputType: string, index) =>
    ({
      borderWidth: inputType === 'box' ? 1 : undefined,
      borderColor: inputType === 'box' ? ('#E30513' as ColorOptions) : undefined,
      borderBottomWidth: highlightBottom ? 2 : 1,
    } as BoxProps),
}
export default styles
